export const PFASSTATE = 'MN';
